module.exports = __webpack_public_path__ + "img/bg.dc4d415c.png";